module.exports = __webpack_public_path__ + "img/gfwz.937858c5.png";